/* 
* <license header>
*/

/**
 * Registrations Dashboard
 * 
 * Main component and modular sub-components that can be 
 * reused or tested independently.
 */

// Main component
export { Registrations } from './Registrations'

// Tab components
export { RegistrationsTab } from './RegistrationsTab'
export { CampaignsTab } from './CampaignsTab'
export { SessionsTab } from './SessionsTab'

// Sub-components (page-specific, not shared)
export { EventSelectorComponent } from './EventSelectorComponent'
export { EventInfoComponent } from './EventInfoComponent'
export { AttendeeFiltersComponent } from './AttendeeFiltersComponent'
export { AttendeeTableComponent } from './AttendeeTableComponent'
